import React, { useState } from "react";
import { useEntityBillingCountQuery } from "@api/flatRateBilling.api";
import { useEntities } from "@hooks/useEntities";
import { useScope } from "@state/scopeContext.lib";
import { Button } from "@design-system/Button/Button";
import styles from "./FlatRateBilling.module.scss";
import { AdditionalEntitiesModal } from "./AdditionalEntitiesModal";

export const AdditionalEntitiesSection: React.FC = () => {
    const { workspaceId } = useScope();
    const businessEntities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });
    const [showAdditionalEntitiesModal, setShowAdditionalEntitiesModal] =
        useState(false);
    const entityBillingCountQuery = useEntityBillingCountQuery({
        workspaceId: workspaceId ?? null,
        enabled: true,
    });

    const entityBillingCount = entityBillingCountQuery.data;

    if (entityBillingCountQuery.isLoading || !entityBillingCount) {
        return null;
    }

    const paidEntityCount = entityBillingCount.additionalEntityCount;
    const freeEntityCount = entityBillingCount.includedInLicenseEntityCount;

    return (
        <>
            <section className={styles.section}>
                <main>
                    <div>
                        <strong>Additional entities</strong>
                        <div className={styles.additionalInfo}>
                            {paidEntityCount} paid, {freeEntityCount} free
                        </div>
                    </div>
                    <aside>
                        <Button
                            variant="primary"
                            size="md"
                            onClick={() => setShowAdditionalEntitiesModal(true)}
                        >
                            View
                        </Button>
                    </aside>
                </main>
            </section>
            {showAdditionalEntitiesModal && (
                <AdditionalEntitiesModal
                    show={showAdditionalEntitiesModal}
                    onHide={() => setShowAdditionalEntitiesModal(false)}
                    entityBillingCount={entityBillingCount}
                    businessEntities={businessEntities}
                />
            )}
        </>
    );
};
